import { useEffect, useContext, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { petitions } from "../../../api/calls";
import { DataContext } from "../../../context/DataContext";
import { toast } from "sonner";
import product from "../../../img/productoVacio.png";
import Table from "../../componentsTable/Table";
import feather from "feather-icons";

export default function ViewSale() {
  const { session, idEmpresa } = useContext(DataContext);
  const [obj, setVenta] = useState({});
  const location = useLocation();
  const idVenta = location.state?.idVenta;
  const main = location.state?.main;
  const [docType, setDocType] = useState("venta");

  const navigate = useNavigate();

  const modalClonar = useRef(null);

  const columns = [
    {
      header: "",
      accessorKey: "foto",
      className: "sort white-space-nowrap align-middle fs-10",
      cell: ({ row }) => (
        <td className="align-middle white-space-nowrap py-2">
          <a
            className="d-block border border-translucent rounded-2"
            href={
              row.original.foto
                ? `data:image/jpeg;base64,${row.original.foto}`
                : product
            }
            data-gallery="gallery-posts-0"
          >
            <img
              className="rounded-2"
              src={
                row.original.foto
                  ? `data:image/jpeg;base64,${row.original.foto}`
                  : product
              }
              alt="Producto"
              width="53"
            />
          </a>
        </td>
      ),
    },
    {
      header: "Nombre",
      accessorKey: "name",
      className: "sort white-space-nowrap align-middle",
      cell: ({ row }) => (
        <td className="products align-middle py-0">
          <span className="fw-semibold line-clamp-3 mb-0 text-primary">
            {row.original.name}
          </span>
        </td>
      ),
    },
    {
      header: "QTY",
      accessorKey: "cantidad",
      className: "sort align-middle text-end ps-4",
      width: "200px",
      cell: ({ row }) => (
        <td className="quantity align-middle text-end py-0 ps-4 text-body-tertiary">
          {row.original.cantidad}
        </td>
      ),
    },
    {
      header: "Precio",
      accessorKey: "precio",
      className: "sort align-middle text-end ps-4",
      width: "150px",
      cell: ({ row }) => (
        <td className="price align-middle text-body fw-semibold text-end py-0 ps-4">
          {row.original.precio.toFixed(2)}
        </td>
      ),
    },
    {
      header: "Descuento",
      accessorKey: "dsctoImporte",
      className: "sort align-middle text-end ps-4",
      width: "150px",
      cell: ({ row }) => (
        <td className="price align-middle text-body fw-semibold text-end py-0 ps-4">
          {row.original.dsctoImporte.toFixed(2)}
        </td>
      ),
    },
    {
      header: "Impuesto",
      accessorKey: "igv",
      className: "sort align-middle text-end ps-4",
      width: "150px",
      cell: ({ row }) => (
        <td className="price align-middle text-body fw-semibold text-end py-0 ps-4">
          {row.original.igv === "S" ? (
            <span className="badge text-bg-success">
              <span className="badge-label">18%</span>
            </span>
          ) : (
            <span className="badge text-bg-secondary">
              <span className="badge-label">0%</span>
            </span>
          )}
        </td>
      ),
    },
    {
      header: "Subtotal",
      accessorKey: "subtotal",
      className: "sort align-middle text-end ps-4",
      width: "150px",
      cell: ({ row }) => (
        <td className="price align-middle text-body fw-semibold text-end py-0 ps-4">
          {(row.original.cantidad * row.original.precio).toFixed(2)}
        </td>
      ),
    },
    {
      header: "Total",
      accessorKey: "importe",
      className: "sort align-middle text-end ps-4",
      width: "250px",
      cell: ({ row }) => (
        <td className="total align-middle fw-bold text-body-highlight text-end py-0 ps-4">
          {row.original.importe.toFixed(2)}
        </td>
      ),
    },
  ];

  useEffect(() => {
    feather.replace();
  }, []);

  useEffect(() => {
    const fetchVenta = async () => {
      const response = await petitions.getVenta(
        idEmpresa(),
        session().token,
        idVenta ?? ""
      );
      if (response.status === "success") {
        setVenta(response.data);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };
    fetchVenta();
  }, [idEmpresa, idVenta, session]);

  const printVenta = async () => {
    const response = await petitions.getReportVenta(
      idEmpresa(),
      session().token,
      idVenta ?? ""
    );
    if (response.isError) {
      toast.error(response.message || "No se pudo obtener el reporte");
      return;
    }

    const fileURL = window.URL.createObjectURL(response.blob);

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = fileURL;

    document.body.appendChild(iframe);

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };
  };

  const clone = async () => {
    obj.status = true; //PARA INDICAR QUE ES UN COMPROBANTE CLONADO
    const modalInstance = window.bootstrap.Modal.getInstance(
      modalClonar.current
    );
    modalInstance.hide();

    let url = "";
    switch (docType) {
      case "venta":
        url = "EmitirComprobantes";  
        break;
      case "cotizacion":
        delete obj?.venta.tipo
        url = "EmitirCotizacion";   
        break;
      case "guiaremision":
        url = "NuevaES";   
        obj.type = "S"
        break;
    }

    obj.detalle = obj.detalle.map((item) => ({
      ...item,
          idPServicio: item.idPServicio ?? "",
          cantidad: item.cantidad ?? 0,
          precio: item.precio ?? 0,
          igv: item.igv ?? "N",
          dscto01: item.dscto01 ?? 0,
          dscto02: item.dscto02 ?? 0,
          subtotal: (item.cantidad * item.precio).toFixed(2),
          dsctoImporte: item.dsctoImporte ?? 0,
          importe: item.importe ?? 0,
          idUsuario: session().idUsuario,
          nombreAlternativo: item.name || "",
    }));

    navigate("/main/" + url, {
      replace: true,
      state: { body: obj },
    });
  };

  return (
    <>
      <div className="mb-9">
        <div className="d-flex align-items-center gap-2">
          <button
            className="px-2 py-1 pt-2 bg-primary-subtle rounded border-0 me-2 rounded-3"
            type="button"
            onClick={() => {
              navigate(main, { replace: true });
            }}
          >
            <span className="fas fa-long-arrow-alt-left"></span>
          </button>
          <h2 className="mb-0">
            Documento{" "}
            <span className="text-body-secondary">
              {obj?.venta?.tipComprobante ?? ""}-
              {obj?.venta?.serComprobante ?? ""}-
              {obj?.venta?.nroComprobante ?? ""}
            </span>
          </h2>
        </div>{" "}
        <div className="d-sm-flex flex-between-center mb-3">
          <p className="text-body-secondary lh-sm mb-0 mt-2 mt-sm-0">
            {obj?.venta?.comprobante} ID :{" "}
            <span className="text-primary fw-bold">{idVenta}</span>
          </p>
          <div className="d-flex">
            <button
              className="btn btn-link pe-3 ps-0 text-body"
              onClick={() => {
                printVenta();
              }}
            >
              <span className="fas fa-print me-2"></span>Imprimir
            </button>
            <button
              className={`btn btn-link px-3 text-body ${
                obj?.venta?.tipComprobante === "07" || obj?.venta?.tipComprobante === "08" ? "disabled" : ""
              }`}
              onClick={() => {
                if (obj.venta.stock === "N") {
                  toast.warning("No puedes clonar un comprobante clonado.")
                  return
                }
                const modal = new window.bootstrap.Modal(modalClonar.current);
                modal.show();
              }}
            >
              <span className="far fa-clone me-2"></span>Clonar
            </button>
            <div className="dropdown">
              <button
                className="btn text-body dropdown-toggle dropdown-caret-none ps-3 pe-0"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Mas acciones<span className="fas fa-chevron-down ms-2"></span>
              </button>
              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <button
                    type="button"
                    className="dropdown-item"
                    onClick={() => {
                      toast.warning("Funcionalidad aun no disponible");
                    }}
                  >
                    Compartir
                  </button>
                </li>
                <li>
                  <button
                    type="button"
                    className="dropdown-item"
                    onClick={() => {
                      toast.warning("Funcionalidad aun no disponible");
                    }}
                  >
                    Ver documentos relacionados
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="row g-5 gy-7">
          <div className="col-12 col-xl-8 col-xxl-9">
            <div
              id="orderTable"
              data-list='{"valueNames":["products","color","size","price","quantity","total"],"page":10}'
              className="mb-3"
            >
              <div className="table-responsive scrollbar">
                <Table
                  data={obj?.detalle || []}
                  columns={columns}
                  classNameTable={
                    "table fs-9 mb-0 border-top border-translucent"
                  }
                  handleRowClick={() => {}}
                />
              </div>
            </div>
            {/* <div className="d-flex flex-between-center py-3 border-bottom border-translucent mb-6">
                <p className="text-body-emphasis fw-semibold lh-sm mb-0">Items subtotal :</p>
                <p className="text-body-emphasis fw-bold lh-sm mb-0">$1690</p>
              </div> */}
            <div className="row gx-4 gy-6 g-xl-7 justify-content-sm-center justify-content-xl-start">
              <div className="col-12 col-sm-auto">
                <h4 className="mb-5">Datos de cliente</h4>
                <div className="row g-4 flex-sm-column">
                  <div className="col-6 col-sm-12">
                    <div className="d-flex align-items-center mb-1">
                      <span
                        className="me-2"
                        data-feather="user"
                        style={{ strokeWidth: 2.5, width: "20px" }}
                      ></span>
                      <h6 className="mb-0">Cliente</h6>
                    </div>
                    <span
                      className="fs-9 ms-4 text-primary"
                      style={{
                        maxWidth: "200px",
                        display: "inline-block",
                        wordBreak: "break-word",
                      }}
                    >
                      {obj?.venta?.nroDocCliente} - {obj?.venta?.razon}
                    </span>
                  </div>
                  <div className="col-6 col-sm-12">
                    <div className="d-flex align-items-center mb-1">
                      <span
                        className="me-2"
                        data-feather="home"
                        style={{ strokeWidth: 2.5, width: "20px" }}
                      ></span>
                      <h6 className="mb-0">Dirección</h6>
                    </div>
                    <div className="ms-4">
                      <p
                        className="text-body-secondary mb-0 fs-9"
                        style={{ wordBreak: "break-word", maxWidth: "200px" }}
                      >
                        {obj?.venta?.direccion}
                      </p>
                    </div>
                  </div>
                  <div className="col-6 col-sm-12">
                    <div className="d-flex align-items-center mb-1">
                      <span
                        className="me-2"
                        data-feather="mail"
                        style={{ strokeWidth: 2.5, width: "20px" }}
                      ></span>
                      <h6 className="mb-0">Email</h6>
                    </div>
                    <a
                      className="fs-9 ms-4 text-break"
                      href={`mailto:${obj?.venta?.email}`}
                      style={{
                        maxWidth: "200px",
                        display: "inline-block",
                        wordBreak: "break-word",
                      }}
                    >
                      {obj?.venta?.email}
                    </a>
                  </div>
                  <div className="col-6 col-sm-12">
                    <div className="d-flex align-items-center mb-1">
                      <span
                        className="me-2"
                        data-feather="phone"
                        style={{ strokeWidth: 2.5, width: "20px" }}
                      >
                        {" "}
                      </span>
                      <h6 className="mb-0">Celular</h6>
                    </div>
                    <a className="fs-9 ms-4" href="tel:+1234567890">
                      {obj?.venta?.celular}
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-auto">
                <h4 className="mb-5">Datos de comprobante</h4>
                <div className="row g-4 flex-sm-column">
                  <div className="col-6 col-sm-12">
                    <div className="d-flex align-items-center mb-1">
                      <span
                        className="me-2"
                        data-feather="credit-card"
                        style={{ strokeWidth: 2.5, width: "20px" }}
                      >
                        {" "}
                      </span>
                      <h6 className="mb-0">Medio de pago</h6>
                    </div>
                    <div className="ms-4">
                      <p
                        className="text-body-secondary mb-0 fs-9"
                        style={{ wordBreak: "break-word", maxWidth: "200px" }}
                      >
                        {obj?.venta?.medioPago}
                      </p>
                    </div>
                  </div>
                  <div className="col-6 col-sm-12">
                    <div className="d-flex align-items-center mb-1">
                      <span
                        className="me-2"
                        data-feather="git-branch"
                        style={{ strokeWidth: 2.5, width: "20px" }}
                      >
                        {" "}
                      </span>
                      <h6 className="mb-0">Tipo de pago</h6>
                    </div>
                    <div className="ms-4">
                      <p
                        className="text-body-secondary mb-0 fs-9"
                        style={{ wordBreak: "break-word", maxWidth: "200px" }}
                      >
                        {obj?.venta?.tipoPago}
                      </p>
                    </div>
                  </div>
                  <div className="col-6 col-sm-12 order-sm-1">
                    <div className="d-flex align-items-center mb-1">
                      <span
                        className="me-2"
                        data-feather="calendar"
                        style={{ strokeWidth: 2.5, width: "20px" }}
                      >
                        {" "}
                      </span>
                      <h6 className="mb-0">Fecha vencimiento</h6>
                    </div>
                    <div className="ms-4">
                      <p className="mb-0 text-body-secondary fs-9">
                        {obj?.venta?.fVencimiento.split("T")[0]}
                      </p>
                    </div>
                  </div>
                  <div className="col-6 col-sm-12">
                    <div className="d-flex align-items-center mb-1">
                      <span
                        className="me-2"
                        data-feather="calendar"
                        style={{ strokeWidth: 2.5, width: "20px" }}
                      ></span>
                      <h6 className="mb-0">Fecha operación</h6>
                    </div>
                    <p className="mb-0 text-body-secondary fs-9 ms-4">
                      {obj?.venta?.fRegistro
                        ? obj.venta.fRegistro.split("T")[0]
                        : ""}{" "}
                      {obj?.venta?.fRegistro
                        ? obj.venta.fRegistro.split("T")[1].split(":")[0]
                        : ""}
                      :
                      {obj?.venta?.fRegistro
                        ? obj.venta.fRegistro.split("T")[1].split(":")[1]
                        : ""}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-auto">
                <h4 className="mb-5">Otros detalles</h4>
                <div className="row g-4 flex-sm-column">
                  <div className="col-6 col-sm-12">
                    <div className="d-flex align-items-center mb-1">
                      <span
                        className="me-2"
                        data-feather="user-check"
                        style={{ strokeWidth: 2.5, width: "20px" }}
                      ></span>
                      <h6 className="mb-0">Usuario</h6>
                    </div>
                    <a
                      className="mb-0 text-body-secondary fs-9 ms-4"
                      style={{
                        maxWidth: "200px",
                        display: "inline-block",
                        wordBreak: "break-word",
                      }}
                    >
                      {obj?.venta?.nameUser}
                    </a>
                  </div>
                  <div className="col-6 col-sm-12">
                    <div className="d-flex align-items-center mb-1">
                      <span
                        className="me-2"
                        data-feather="package"
                        style={{ strokeWidth: 2.5, width: "20px" }}
                      ></span>
                      <h6 className="mb-0">Cant. items</h6>
                    </div>
                    <p className="mb-0 text-body-secondary fs-9 ms-4">
                      {obj?.venta?.numItems}
                    </p>
                  </div>
                  <div className="col-6 col-sm-12">
                    <div className="d-flex align-items-center mb-1">
                      <span
                        className="me-2"
                        data-feather="info"
                        style={{ strokeWidth: 2.5, width: "20px" }}
                      >
                        {" "}
                      </span>
                      <h6 className="mb-0">Estado</h6>
                    </div>
                    <p className="mb-0 text-body-secondary fs-9 ms-4">
                      {obj?.venta?.anulado === "S" ? (
                        <span className="badge text-bg-danger">
                          <span className="badge-label">Anulado</span>
                        </span>
                      ) : (
                        <span className="badge text-bg-success">
                          <span className="badge-label">Operativo</span>
                        </span>
                      )}
                    </p>
                  </div>
                  <div className="col-6 col-sm-12">
                    <div className="d-flex align-items-center mb-1">
                      <span
                        className="me-2"
                        data-feather="dollar-sign"
                        style={{ strokeWidth: 2.5, width: "20px" }}
                      >
                        {" "}
                      </span>
                      <h6 className="mb-0">Moneda</h6>
                    </div>
                    <div className="ms-4">
                      <p className="text-body-secondary fs-9 mb-0">
                        {obj?.venta?.simbolo}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-xl-4 col-xxl-3">
            <div className="row">
              <div className="col-12">
                <div className="card mb-3 rounded-4 border-0 shadow-sm">
                  <div className="card-body">
                    <h3 className="card-title mb-4">
                      {obj?.venta?.comprobante}
                    </h3>
                    <div>
                      <div className="d-flex justify-content-between">
                        <p className="text-body fw-semibold">Sub total :</p>
                        <p className="text-body-emphasis fw-semibold">
                          {obj?.venta?.simbolo}
                          {obj?.venta?.subtotal.toFixed(2)}
                        </p>
                      </div>
                      <div className="d-flex justify-content-between">
                        <p className="text-body fw-semibold">Descuento :</p>
                        <p className="text-danger fw-semibold">
                          -{obj?.venta?.simbolo}
                          {obj?.venta?.impDsctoTotal.toFixed(2)}
                        </p>
                      </div>
                      <div className="d-flex justify-content-between">
                        <p className="text-body fw-semibold">Impuesto :</p>
                        <p className="text-body-emphasis fw-semibold">
                          {obj?.venta?.simbolo}
                          {obj?.venta?.impuesto.toFixed(2)}
                        </p>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between border-top border-translucent border-dashed pt-4">
                      <h4 className="mb-0">Total :</h4>
                      <h4 className="mb-0">
                        {obj?.venta?.simbolo}
                        {obj?.venta?.impTotal.toFixed(2)}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    <h3 className="card-title mb-4">Order Status</h3>
                    <h6 className="mb-2">Payment status</h6>
                    <select
                      className="form-select mb-4"
                      aria-label="delivery type"
                    >
                      <option value="cod">Processing</option>
                      <option value="card">Canceled</option>
                      <option value="paypal">Completed</option>
                    </select>
                    <h6 className="mb-2">Fulfillment status</h6>
                    <select className="form-select" aria-label="delivery type">
                      <option value="cod">Unfulfilled</option>
                      <option value="card">Fulfilled</option>
                      <option value="paypal">Pending</option>
                    </select>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="documentModal"
        tabIndex="-1"
        aria-labelledby="documentModalLabel"
        aria-hidden="true"
        ref={modalClonar}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-5 p-3">
            {/* Header */}
            <div className="modal-header border-0">
              <h3 className="modal-title " id="documentModalLabel">
                Elija documento destino
              </h3>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            {/* Body */}
            <div className="modal-body">
              <div className="list-group rounded-3">
                <label className="list-group-item d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center text-primary fw-bold">
                    <span className="far fa-file-alt text-secondary fs-4 me-4"></span>
                    Venta
                  </div>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="docType"
                    value="venta"
                    checked={docType === "venta"}
                    onChange={(event) => {
                      setDocType(event.target.value);
                    }}
                  />
                </label>

                {/* Opción Cotización */}
                <label className="list-group-item d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center text-primary fw-bold">
                    <span className="far fa-file-archive text-secondary fs-4 me-4"></span>
                    Cotización
                  </div>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="docType"
                    value="cotizacion"
                    checked={docType === "cotizacion"}
                    onChange={(event) => {
                      setDocType(event.target.value);
                    }}
                  />
                </label>

                {/* Opción Guía de Remisión */}
                <label className="list-group-item d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center text-primary fw-bold">
                    <span className="fas fa-caravan text-secondary fs-4 me-2"></span>
                    Guía de Remisión
                  </div>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="docType"
                    value="guiaremision"
                    checked={docType === "guiaremision"}
                    onChange={(event) => {
                      setDocType(event.target.value);
                    }}
                  />
                </label>
              </div>
            </div>

            {/* Footer */}
            <div className="modal-footer border-0">
              <button
                type="button"
                className="btn btn-subtle-secondary"
                data-bs-dismiss="modal"
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-subtle-primary"
                onClick={() => {
                  clone();
                }}
              >
                Clonar
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
